<template>
    <div :class="['divide-input', myself ? 'myself' : '']">
        <div class="user">
            <img v-if="myself" src="@/assets/img/distribute/icon_benr.svg" />
            <img v-else src="@/assets/img/distribute/icon_fenzr.svg" />
            <p>{{ myself ? '本人' : '分账人' }}</p>
        </div>
        <div class="name">
            <label>真实姓名</label>
            <p v-if="disabled">{{ formData.name }}</p>
            <el-input v-else v-model="formData.name" @change="onChange" name="name" placeholder="请输入真实姓名" />
        </div>
        <div class="phone">
            <label>手机号</label>
            <p v-if="disabled">{{ formData.telephone }}</p>
            <el-input v-else v-model="formData.telephone" @change="onChange" name="telephone" placeholder="请输入手机号" />
        </div>
        <div class="proportion">
            <label>结算比例</label>
            <p v-if="disabled">{{ formData.ratio }}%</p>
            <el-input v-else v-model="formData.ratio" @change="onChange" name="ratio" placeholder="请输入结算比例">
                <template slot="append">%</template>
            </el-input>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        info: {
            type: Object,
            default: () => null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        myself: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            formData: {
                name: '',
                telephone: '',
                ratio: '',
            },
        };
    },
    watch: {
        info: {
            handler(val) {
                if (val) this.formData = JSON.parse(JSON.stringify(val));
            },
            immediate: true,
        },
    },
    methods: {
        onChange() {
            const {name, telephone, ratio} = this.formData;
            if (!ratio || !name || !telephone) return;
            if (!/.*[\u4e00-\u9fa5]+.*/.test(name)) return this.$message.error('请输入正确的姓名格式');
            if (!/^[0-9]{11}$/.test(telephone)) return this.$message.error('请输入正确的手机号码');
            if (!/^(?:(?:100(?:\.0{1,2})?)|(?:\d{1,2}(?:\.\d{1,2})?))$/.test(ratio)) return this.$message.error('比例不得超过100%');
            const value = {name, telephone, ratio, isEdit: true};
            if (this.info.ruleId) value.ruleId = this.info.ruleId;
            if (ratio && name && telephone) this.$emit('update', value);
        },
    },
};
</script>
<style lang="scss">
.divide-input {
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: 1px solid $--border-color-base;
    padding: 20px 0;

    .name,
    .phone,
    .proportion {
        flex: 1;
        padding: 0 30px;

        p {
            font-size: 16px;
            color: $-text-600;
            font-weight: 600;
            margin-top: 16px;
            line-height: 16px;
        }

        label {
            font-size: 12px;
            color: $-text-600;
        }

        .el-input {
            .el-input-group__append {
                background-color: transparent;
                font-weight: bold;
                color: $-text-950;
                padding: 0px;
            }
            .el-input__inner {
                border-top: none;
                border-left: none;
                border-right: none;
                border-radius: 0px;
                padding: 0px;
            }
            &.is-disabled {
                .el-input__inner {
                    background-color: transparent !important;
                    border-bottom: none;
                    font-size: 16px;
                    font-weight: bold;
                    color: $-text-950;
                }
            }
        }
    }

    .user {
        text-align: center;
        padding: 8px 60px;
        border-right: 1px dashed $--border-color-base;

        p {
            margin-top: 12px;
        }
    }

    &.myself {
        background: #f5f7fa;
    }
}
</style>
